import type { RouteObject } from 'react-router';

// I5 (trust track): Settings → Status page, nested under the admin layout in modules/admin/routes.tsx.
// The status page admin lives in the platform console (/platform/status-page).
export const settingsRoutes: RouteObject[] = [];
